import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Signup from './pages/Signup';
import ProfileCompletion from './pages/ProfileCompletion';
import Login from './pages/Login';
import EditListing from './pages/EditListing';
import { AuthProvider } from './contexts/AuthContext';
import Dashboard from './pages/Dashboard';
import ListingPage from './pages/ListingPage';

function App() {
  const [usingDummyData, setUsingDummyData] = useState(false);

  return (
    <AuthProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/profile-completion" element={<ProfileCompletion />} />
              <Route 
                path="/edit-listing" 
                element={<EditListing onSuccess={() => {}} />}
              />
              <Route 
                path="/edit-listing/:id" 
                element={<EditListing onSuccess={() => {}} />} 
              />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/listing/:id" element={<ListingPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
